import React, { useState } from 'react';

// Data derived from your request
const LOBBYING_DATA = {
    "Artificial Intelligence & Emerging Tech": {
        issues: [
            { name: "Regulatory Frameworks", template: "We are advocating for consistent [State/Federal] rules on AI governance to avoid a 'patchwork' of conflicting laws regarding [Specific Tech]." },
            { name: "Infrastructure & Sovereignty", template: "We seek government support for [Data Center/Compute] infrastructure to meet [EU/Local] data sovereignty laws." },
            { name: "Strategic Incentives", template: "We are applying for a share of strategic investments for AI workforce readiness in the [Sector Name] sector." }
        ]
    },
    "Trade, Tariffs, & Supply Chains": {
        issues: [
            { name: "Tariff Relief", template: "We are negotiating for exemptions from 2026 tariffs on [Component Name], which are critical to our supply chain." },
            { name: "Market Diversification", template: "We seek government backing to establish new trade corridors with [Country, e.g., India/Türkiye] to reduce dependency on traditional hubs." },
            { name: "Critical Dependencies", template: "We are lobbying for subsidies/licenses regarding [Semiconductors/Minerals], deemed mission-critical." }
        ]
    },
    "Taxes & Financial Policy": {
        issues: [
            { name: "Legislative Changes", template: "We are addressing impacts from the 'One, Big, Beautiful Bill', specifically regarding overtime pay exemptions." },
            { name: "Incentives for Innovation", template: "We request tax relief/credits for R&D investments in [Product/Technology] to boost productivity." }
        ]
    },
    "ESG & Climate Policy": {
        issues: [
            { name: "Reporting Standards", template: "We require assistance reconciling conflicting reporting regimes (EU CSRD vs ISSB) for our multi-national operations." },
            { name: "Anti-ESG Legislation", template: "We are challenging state-level anti-ESG bills that limit our financial institution choices in [State/Region]." }
        ]
    },
    "Employment & Labor": {
        issues: [
            { name: "Mandates & Costs", template: "We are raising concerns regarding the cost impact of new [Sick Leave/Minimum Wage] mandates on small business operations." },
            { name: "Talent Access", template: "We are lobbying for immigration reforms to fast-track highly skilled [STEM/AI] talent visas." }
        ]
    }
};

const LobbyingWizard = () => {
    const [domain, setDomain] = useState('');
    const [issue, setIssue] = useState('');
    const [draft, setDraft] = useState('');

    const handleDomainChange = (e) => {
        setDomain(e.target.value);
        setIssue('');
        setDraft('');
    };

    const handleIssueChange = (e) => {
        const selectedIssue = e.target.value;
        setIssue(selectedIssue);
        const template = LOBBYING_DATA[domain].issues.find(i => i.name === selectedIssue)?.template;
        setDraft(template || '');
    };

    return (
        <div className="bg-white p-6 rounded-xl shadow border border-slate-200">
            <h2 className="text-2xl font-bold text-slate-800 mb-2">⚖️ Lobbying & Advocacy Engine</h2>
            <p className="text-sm text-slate-600 mb-6">
                Define your regulatory roadblocks. Aulice aggregates these requests to advocate for policy changes.
            </p>

            <div className="space-y-4">
                {/* Level 1 */}
                <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase mb-1">1. Policy Domain</label>
                    <select className="w-full p-3 border rounded bg-slate-50" value={domain} onChange={handleDomainChange}>
                        <option value="">-- Select Domain --</option>
                        {Object.keys(LOBBYING_DATA).map(d => <option key={d} value={d}>{d}</option>)}
                    </select>
                </div>

                {/* Level 2 */}
                {domain && (
                    <div className="animate-fade-in">
                        <label className="block text-xs font-bold text-slate-500 uppercase mb-1">2. Specific Issue</label>
                        <select className="w-full p-3 border rounded bg-slate-50" value={issue} onChange={handleIssueChange}>
                            <option value="">-- Select Issue --</option>
                            {LOBBYING_DATA[domain].issues.map(i => <option key={i.name} value={i.name}>{i.name}</option>)}
                        </select>
                    </div>
                )}

                {/* Level 3: Template */}
                {issue && (
                    <div className="animate-fade-in">
                        <label className="block text-xs font-bold text-slate-500 uppercase mb-1">3. Advocacy Template (Edit as needed)</label>
                        <textarea 
                            className="w-full h-32 p-4 border border-indigo-200 bg-indigo-50 rounded text-sm font-mono text-slate-700 focus:ring-2 focus:ring-indigo-500"
                            value={draft}
                            onChange={(e) => setDraft(e.target.value)}
                        />
                        <button className="mt-4 w-full bg-slate-900 text-white py-3 rounded font-bold hover:bg-black transition">
                            Submit to Policy Team
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LobbyingWizard;